export default function queryParser(query = '') {
  const trimmed_m = query.replace(/,/g, ' ').trim();
  
  return encodeURIComponent(trimmed_m);
}